export interface IRouteEventAlert {
  id?: string;
  eventType?: string | null;
  routeName?: string | null;
  routeId?: number | null;
  truckImplementId?: number | null;
  licensePlate?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  created?: string | null;
}

export const defaultValue: Readonly<IRouteEventAlert> = {};
